import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import {
  type CreateLeadAssignmentPayload,
  leadAssignmentAPI,
  type UpdateLeadAssignmentPayload,
} from '../lib/api';

export function useLeadAssignment(organizationId: string | undefined) {
  return useQuery({
    queryKey: ['lead-assignment', organizationId],
    queryFn: async () => {
      const { data } = await leadAssignmentAPI.getRule(organizationId!);
      return data;
    },
    enabled: !!organizationId,
  });
}

export function useCreateLeadAssignment() {
  const queryClient = useQueryClient();
  const { currentOrganization } = useAuth();

  return useMutation({
    mutationFn: async (payload: CreateLeadAssignmentPayload) => {
      const { data } = await leadAssignmentAPI.createRule(payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lead-assignment', currentOrganization?.id] });
    },
  });
}

export function useUpdateLeadAssignment() {
  const queryClient = useQueryClient();
  const { currentOrganization } = useAuth();

  return useMutation({
    mutationFn: async (payload: UpdateLeadAssignmentPayload) => {
      const orgId = currentOrganization?.id;
      if (!orgId) throw new Error('No organization selected');
      const { data } = await leadAssignmentAPI.updateRule(orgId, payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lead-assignment', currentOrganization?.id] });
    },
  });
}
